import React from 'react';
const blocks = [{
  name: 'Stick warm-up in pods',
  min: 8,
  color: 'bg-turf'
}, {
  name: 'Skill builder',
  min: 15,
  color: 'bg-sky'
}, {
  name: 'Small-sided game',
  min: 15,
  color: 'bg-gold'
}, {
  name: 'Scrimmage with one rule',
  min: 17,
  color: 'bg-navy-line'
}, {
  name: '3-min huddle',
  min: 5,
  color: 'bg-white/30'
}];
const coverage = [{
  label: 'The 3-per-ball rule',
  body: 'Pods of 3 kids per ball instead of lines of 8 — everyone touching the ball'
}, {
  label: '60 · 75 · 90 minutes',
  body: 'Same five blocks, timing already worked out for your slot'
}, {
  label: 'Two age groups',
  body: 'U8–U10 and U12–U14 on every plan'
}, {
  label: 'Rule notes',
  body: 'Field boys / field girls wherever contact, sticks or numbers change'
}, {
  label: 'One coach? Fine',
  body: 'A 1-coach version on every plan, plus big-group setups for 20+ kids'
}, {
  label: 'Minimal gear',
  body: 'Cones, balls and cone goals — the minimum is listed on every plan'
}];
export function ProductReveal() {
  return <section aria-labelledby="mechanism-heading" className="w-full border-y-4 border-turf bg-navy" data-id="element-227" data-mp="1b1qtluuwqkpb">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-228" data-mp="1f1hift0viqr7">
        <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-gold" data-id="element-229" data-mp="1jtj588vo3zvh">The system</p>
        <h2 id="mechanism-heading" className="mt-3 font-display font-bold uppercase text-white text-3xl sm:text-5xl" data-id="element-230" data-mp="1os2q05yiz5m9">
          The No-Lines Practice Formula
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base sm:text-lg text-white/80" data-id="element-231" data-mp="w3f2s4u7u662">
          2,000 drills don&apos;t help when you don&apos;t know which one to run on
          Tuesday. The problem was never the number of drills — it&apos;s turning
          them into a practice. Every No-Lines practice follows the same five
          blocks, with kids in small pods instead of lines, so nobody waits and
          you never plan from scratch. Open the week, pick your age group, run
          the plan.
        </p>

        {/* 60-minute practice timeline */}
        <div className="mx-auto mt-9 max-w-3xl text-left" data-id="element-232" data-mp="1ruyubmv0y8yc">
          <p className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-233" data-mp="1msrcwhrfe0om">
            A 60-minute practice
          </p>
          <div className="mt-2 flex h-11 w-full overflow-hidden rounded-xl border border-navy-line" data-id="element-234" data-mp="21oz6u9smygh3">
            {blocks.map(b => <div key={b.name} style={{
            flexGrow: b.min,
            flexBasis: 0
          }} className={`${b.color} flex items-center justify-center font-display text-base font-bold text-white`} data-id="element-235" data-mp="191uxxtqf9i01">
                {b.min}′
              </div>)}
          </div>
          <ol className="mt-3 grid grid-cols-2 gap-x-4 gap-y-1.5 text-[12.5px] text-white/75 sm:grid-cols-5" data-id="element-236" data-mp="1e17ho5lzy8ye">
            {blocks.map((b, i) => <li key={b.name} className="flex items-center gap-1.5" data-id="element-237" data-mp="q9sb20n6t5hc" data-mpi={i}>
                <span className={`h-2.5 w-2.5 flex-none rounded-sm ${b.color}`} data-id="element-238" data-mp="lc0mnglr41hw" />
                {i + 1}. {b.name}
              </li>)}
          </ol>
        </div>

        <ul className="mt-10 grid gap-2.5 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-239" data-mp="31r5bbwksfqra">
          {coverage.map(item => <li key={item.label} className="rounded-lg border border-navy-line bg-white/5 px-4 py-3" data-id="element-240" data-mp="2n3amir9wi6jh">
              <span className="block text-[11px] font-semibold uppercase tracking-widest text-gold" data-id="element-241" data-mp="2s1lsgqx2rwwf">
                {item.label}
              </span>
              <span className="mt-1 block text-sm text-white/85" data-id="element-242" data-mp="3kphlnlnfr6og">{item.body}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}